import React from 'react'

import {requestOption} from './helpers/requestOption'
import { handleResponse } from './helpers/handleResponse';
import {makeApiUrl} from "./helpers/makeApiUrl";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showError: process.env.NODE_ENV !== 'production',
            error: null,
            errorInfo: null,
        };
    }


    logError(error, stack) {
        let url 	= makeApiUrl('spa/log');
        let data    = {error: error.toString(), stack: stack, mode: process.env.NODE_ENV};
        fetch(url, requestOption(data));
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        this.logError(error.toString(), errorInfo.componentStack);
    }


    render() {
        if (this.state.showError && this.state.errorInfo) {
            return (
                <div>
                    <h2>Upsss coś poszło nie tak.</h2>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo.componentStack}
                    </details>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;